import * as React from 'react'
import { useTiptapEditor } from '@tiptap-ui/hooks/use-tiptap-editor'
import { TableIcon } from '@tiptap-ui/components/tiptap-icons/table-icon'

// Default insertion args (kept here to compute capability state)
const INSERT_TABLE_DEFAULT = { rows: 3, cols: 3, withHeaderRow: true }

function canAction (editor, fn) {
  return !!editor?.can()?.chain().focus()[fn]().run()
}
function canInsertTable (editor) {
  return !!editor?.can()?.chain().focus().insertTable(INSERT_TABLE_DEFAULT).run()
}

// Hook encapsulating state + subscription for the table dropdown
export function useTableDropdownMenu ({ editor: providedEditor }) {
  const { editor } = useTiptapEditor(providedEditor)
  const [enabledMap, setEnabledMap] = React.useState({})
  const [isActive, setIsActive] = React.useState(false)

  const isVisible = !!editor // always visible if editor exists
  const canOpen = !!editor

  React.useEffect(() => {
    if (!editor) {
      return
    }
    const compute = () => {
      setIsActive(!!editor.isActive('table'))
      const inTable = !!editor.isActive('table')
      setEnabledMap({
        insertTable: !inTable && canInsertTable(editor),
        addRowAfter: canAction(editor, 'addRowAfter'),
        addColumnAfter: canAction(editor, 'addColumnAfter'),
        deleteRow: canAction(editor, 'deleteRow'),
        deleteColumn: canAction(editor, 'deleteColumn'),
        deleteTable: canAction(editor, 'deleteTable'),
      })
    }
    editor.on('selectionUpdate', compute)
    editor.on('transaction', compute)
    compute()
    return () => {
      editor.off('selectionUpdate', compute)
      editor.off('transaction', compute)
    }
  }, [editor])

  return {
    editor,
    isVisible,
    isActive,
    canOpen,
    enabledMap,
    Icon: TableIcon,
  }
}

export default useTableDropdownMenu
